<template>
  <div class="preview" style="weight: 100%">
    <div
      v-for="(msg, key) in mensagens"
      class="w-100 d-flex mb-3"
      :class="{
        'justify-content-end': msg.fromMe,
        'justify-content-start': !msg.fromMe
      }"
      :key="key"
    >
      <div
        class="message"
        :class="{ 'from-me': msg.fromMe, 'from-them': !msg.fromMe }"
      >
        <div
          style="padding: 7px 7px 6px 9px"
          v-html="formatTextToHTML(msg.text)"
        ></div>

        <!-- <div
          class="d-flex justify-content-between w-100"
          style="padding: 7px 7px 6px 9px"
        >
          <time aria-hidden="true" class="_6xe5">{{ hora }}</time>
        </div> -->

        <!-- <div v-if="temBotao" style="padding: 7px 7px 6px 9px; min-width: 200px">
          <div
            class="d-flex justify-content-center w-100 py-3"
            v-for="(botao, key) in botoes"
            style="border-top: 1px solid #dadde1"
            :key="key"
          >
            <div :class="`icone ${botao.type.toLowerCase()}`" />
            <span class="_alr0 ml-2">{{ botao.text }}</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ChatPreviewWhatsapp",
  components: {},
  props: {
    mensagens: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    hora() {
      return moment().format("LT");
    }
  },
  methods: {
    formatTextToHTML(text) {
      if (!text) return "";
      text = text.replaceAll(
        /_([^_]+)_/g,
        '<span style="font-style: italic">$1</span>'
      );
      text = text.replaceAll(/\*([^*]+)\*/g, "<strong>$1</strong>");
      text = text.replaceAll(/~([^~]+)~/g, "<s>$1</s>");
      text = text.replaceAll(/```([^`]+)```/g, "<code>$1</code>");
      text = text.replaceAll("\n", "<br>");
      return text;
    }
  },
  watch: {}
};
</script>

<style scoped>
.preview {
  background-color: #e5ddd5;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 0;
  padding: 20px 20px;
  transition: all 0.5s ease-in-out;
}
.preview::before {
  background: url(../../automacao/template-whatsapp/assets/background.png);
  background-size: 366.5px 666px;
  content: "";
  height: 100%;
  /* left: 0; */
  opacity: 0.06;
  position: absolute;
  top: 0;
  width: 100%;
}

.message {
  background-color: #fff;
  border-radius: 7.5px;
  border-top-left-radius: 0;
  box-shadow: 0 1px 0.5px rgba(0, 0, 0, 0.15);
  min-height: 20px;
  position: relative;
  word-wrap: break-word;
  box-sizing: border-box;
  display: block;
  font-family: BlinkMacSystemFont, -apple-system, Roboto, Arial, sans-serif;
  max-width: 280px;
  position: relative;
  margin: 0;
}

.from-them {
  background-color: #fff;
  border-top-left-radius: 0;
  border-top-right-radius: 7.5px;
}

.from-me {
  background-color: #dcf8c6;
  border-top-right-radius: 0;
  border-top-left-radius: 7.5px;
}

.from-them::after {
  background: url(../../automacao/template-whatsapp/assets/orelhinha.png) 50%
    50% no-repeat;
  background-size: contain;
  content: "";
  height: 19px;
  left: -12px;
  position: absolute;
  top: 0;
  width: 12px;
}

.from-me::before {
  background: url(../../automacao/template-whatsapp/assets/orelhinha-me.png) 50%
    50% no-repeat;
  background-size: contain;
  content: "";
  height: 19px;
  right: -12px;
  position: absolute;
  top: 0;
  width: 12px;
  transform: scaleX(-1);
}

._6xe5 {
  bottom: 3px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 11px;
  height: 15px;
  line-height: 15px;
  /* position: absolute; */
  right: 7px;
}

.icone {
  background-repeat: no-repeat;
  background-size: contain;
  flex-shrink: 0;
  height: 16px;
  opacity: 0.8;
  width: 16px;
}

.url {
  background-image: url(../../automacao/template-whatsapp/assets/url.png);
}

.copy_code {
  background-image: url(../../automacao/template-whatsapp/assets/copy_code.png);
}

.otp {
  background-image: url(../../automacao/template-whatsapp/assets/copy_code.png);
}

.phone_number {
  background-image: url(../../automacao/template-whatsapp/assets/phone_number.png);
}
.quick_reply {
  background-image: url(../../automacao/template-whatsapp/assets/quick_reply.png);
}
.list {
  background-image: url(../../automacao/template-whatsapp/assets/list.png);
}

._alr0 {
  color: #00a5f4;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
}

._7r39 {
  background-color: #ccd0d5;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80px 80px;
  border-radius: 4px;
  box-sizing: border-box;
  min-width: 240px;
  min-height: 180px;
}

.document {
  background-image: url(../../automacao/template-whatsapp/assets/document.png);
}
.player {
  background-image: url(../../automacao/template-whatsapp/assets/player.png);
}

._7qiw {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  line-height: 17px;
  padding: 0 7px 8px 9px;
}
</style>
#d9fdd3
